import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { verifyUser } from "../PrivateRoute";
import { useEffect } from "react";
import useAxiosInterceptor from "../utils/axiosInterceptors";
export default function RootLayout() {
  useAxiosInterceptor();
  useEffect(() => {
    const token = sessionStorage.getItem("access_token");
    if (token)
      verifyUser()
  }, []);
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}
